import { ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';

export class CustomValidators {
  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn  {
    return (control: AbstractControl): ValidationErrors | null=> {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }

  static emailOrPhoneValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phonePattern = /^\d{10,13}$/;
  
    if (!value) return { required: true };
  
    if (emailPattern.test(value) || phonePattern.test(value)) {
      return null; // valid
    }
    return { invalidUsername: true }; // invalid
  }

  static passwordMatchValidator(control:AbstractControl):ValidationErrors | null{
      const password = control.get('password');
      const confirmPassword = control.get('confirmPassword');
      if(!password || !confirmPassword){
        return null;
      }

      return password.value === confirmPassword.value ? null : { passwordMismatch: true };
  }

 
}